import { useNavigate } from 'react-router-dom';
import * as React from 'react';
import styled from '@emotion/styled';

export const immediateAction = (action: () => any) => {
  if ('ontouchstart' in document.documentElement) {
    return {
      onTouchStart: () => {
        action();
      }
    };
  }
  return {
    onClick: () => {
      action();
    }
  };
};

export interface AppLinkProps {
  className?: any;
  push?: boolean;
  to: any;
}

export const AppLink: React.FC<React.PropsWithChildren<AppLinkProps>> = (props) => {
  const navigate = useNavigate();
  return (
    <S.Link
      className={props.className}
      onClick={() => {
        navigate(props.to, props.push ? { state: 'push' } : {});
      }}
    >
      {props.children}
    </S.Link>
  );
};

namespace S {
  export const Link = styled.div`
    cursor: pointer;
  `;
}
